// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SurveyverkstedRouteImport } from './routes/surveyverksted'
import { Route as SurveyPreviewRouteImport } from './routes/survey-preview'
import { Route as ReleaseVerificationRouteImport } from './routes/release-verification'
import { Route as FeedbackRouteImport } from './routes/feedback'
import { Route as ExportRouteImport } from './routes/export'
import { Route as AnalyseprodukterRouteImport } from './routes/analyseprodukter'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SurveyverkstedIndexRouteImport } from './routes/surveyverksted.index'
import { Route as SurveyverkstedProjectIdRouteImport } from './routes/surveyverksted.$projectId'
import { Route as SurveyverkstedRevisionsRevisionIdRouteImport } from './routes/surveyverksted.revisions.$revisionId'

const SurveyverkstedRoute = SurveyverkstedRouteImport.update({
            id: '/surveyverksted',path: '/surveyverksted',getParentRoute: () => rootRouteImport
          })
const SurveyPreviewRoute = SurveyPreviewRouteImport.update({
            id: '/survey-preview',path: '/survey-preview',getParentRoute: () => rootRouteImport
          })
const ReleaseVerificationRoute = ReleaseVerificationRouteImport.update({
            id: '/release-verification',path: '/release-verification',getParentRoute: () => rootRouteImport
          })
const FeedbackRoute = FeedbackRouteImport.update({
            id: '/feedback',path: '/feedback',getParentRoute: () => rootRouteImport
          })
const ExportRoute = ExportRouteImport.update({
            id: '/export',path: '/export',getParentRoute: () => rootRouteImport
          })
const AnalyseprodukterRoute = AnalyseprodukterRouteImport.update({
            id: '/analyseprodukter',path: '/analyseprodukter',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SurveyverkstedIndexRoute = SurveyverkstedIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SurveyverkstedRoute
          })
const SurveyverkstedProjectIdRoute = SurveyverkstedProjectIdRouteImport.update({
            id: '/$projectId',path: '/$projectId',getParentRoute: () => SurveyverkstedRoute
          })
const SurveyverkstedRevisionsRevisionIdRoute = SurveyverkstedRevisionsRevisionIdRouteImport.update({
            id: '/revisions/$revisionId',path: '/revisions/$revisionId',getParentRoute: () => SurveyverkstedRoute
          })





const SurveyverkstedRouteChildren = {
  SurveyverkstedProjectIdRoute: SurveyverkstedProjectIdRoute,SurveyverkstedIndexRoute: SurveyverkstedIndexRoute,SurveyverkstedRevisionsRevisionIdRoute: SurveyverkstedRevisionsRevisionIdRoute
}

const SurveyverkstedRouteWithChildren = SurveyverkstedRoute._addFileChildren(SurveyverkstedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AnalyseprodukterRoute: AnalyseprodukterRoute,ExportRoute: ExportRoute,FeedbackRoute: FeedbackRoute,ReleaseVerificationRoute: ReleaseVerificationRoute,SurveyPreviewRoute: SurveyPreviewRoute,SurveyverkstedRoute: SurveyverkstedRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)